module.exports = __webpack_public_path__ + "img/app-logo.840eb448.png";